import { LineChart } from "lucide-react";
import type { ModuleSpec } from "../types";

/**
 * Team Insights — agent and team-performance analytics.
 *
 * Renamed from generic "Analytics" because the surface focuses on team work:
 * response times, resolution times, agent leaderboards, channel mix, queue
 * load, and SLA compliance. Spec id stays `analytics` so the existing route
 * `/analytics` and permission `read:analytics` continue to work.
 */
export const analyticsSpec: ModuleSpec = {
  id: "analytics",
  icon: LineChart,
  i18n: {
    namespace: "modules",
    titleKey: "analytics.title",
    descriptionKey: "analytics.description",
  },
  nav: {
    path: "/analytics",
    group: "team",
    order: 30,
  },
  permission: {
    action: "read",
    subject: "analytics",
  },
  meta: {
    status: "active",
    description: "Agent performance, response times, and team workload",
  },
};
